/** Eenmalige Backlog-intro bij eerste keer Backlog-tab (backlogIntro). */
import { useCallback, useEffect, useRef, useState } from 'react';
import { ONBOARDING_HINT_BACKLOG_INTRO } from '@/constants/onboardingHints';
import { useTier } from '@/features/tier/useTier';
import { markHintSeen } from '@/services/userService';

/**
 * @param {Object} params
 * @param {boolean} params.isBacklogTab
 * @param {string | undefined} params.userId
 */
export function useBacklogIntroHint({ isBacklogTab, userId }) {
  const { seenHints, profileLoaded } = useTier();
  const initRef = useRef(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isBacklogTab || !userId || !profileLoaded) {
      return;
    }
    if (initRef.current) {
      return;
    }
    initRef.current = true;
    if (seenHints.includes(ONBOARDING_HINT_BACKLOG_INTRO)) {
      return;
    }
    setOpen(true);
    void markHintSeen(userId, ONBOARDING_HINT_BACKLOG_INTRO);
  }, [isBacklogTab, userId, profileLoaded, seenHints]);

  const dismiss = useCallback(() => {
    setOpen(false);
  }, []);

  return { showHint: open, dismissHint: dismiss };
}
